module.exports = __webpack_public_path__ + "img/binary-circle-check.51dcd66a.svg";